document.addEventListener('DOMContentLoaded', function(dom) {
  const navbar = dom.target.querySelectorAll('.js-navbar')
})
